import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import NavigationBar from './components/NavigationBar';
import SurveyList from './pages/SurveyList';
import SurveyDetail from './pages/SurveyDetail';
import CreateSurvey from './pages/CreateSurvey';
import EditSurvey from './pages/EditSurvey';
import ImportSurvey from './pages/ImportSurvey';
import SessionList from './pages/SessionList';
import SessionDetail from './pages/SessionDetail';
import CreateSession from './pages/CreateSession';
import RealtimeSession from './pages/RealtimeSession';
import './App.css';

function App() {
  return (
    <>
      <NavigationBar />
      <Container className="py-4">
        <Routes>
          <Route path="/" element={<SurveyList />} />
          <Route path="/surveys/create" element={<CreateSurvey />} />
          <Route path="/surveys/import" element={<ImportSurvey />} />
          <Route path="/surveys/:surveyId" element={<SurveyDetail />} />
          <Route path="/surveys/:surveyId/edit" element={<EditSurvey />} />
          <Route path="/surveys/:surveyId/sessions" element={<SessionList />} />
          <Route path="/surveys/:surveyId/sessions/create" element={<CreateSession />} />
          <Route path="/sessions/:sessionId" element={<SessionDetail />} />
          <Route path="/sessions/:sessionId/realtime" element={<RealtimeSession />} />
        </Routes>
      </Container>
    </>
  );
}

export default App;